import { render } from "./inventory_account_detail.vue?vue&type=template&id=36713c81&scoped=true"
import script from "./inventory_account_detail.vue?vue&type=script&lang=js"
export * from "./inventory_account_detail.vue?vue&type=script&lang=js"

import "./inventory_account_detail.vue?vue&type=style&index=0&id=36713c81&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36713c81"]])

export default __exports__